import { lazy } from "react";
import { Briefcase } from "lucide-react";
import type { AdminPlugin } from "@/plugins/types";

const Applications = lazy(() => import("@/pages/admin/Applications"));

const applicationsPlugin: AdminPlugin = {
  id: "applications",
  label: "Applications",
  icon: Briefcase,
  route: "applications",
  component: Applications,
  menuOrder: 2,
};

export default applicationsPlugin;
